module.exports = __webpack_public_path__ + "static/media/12_r_stalinka_73.7_0.83.60d60dd2.png";